(function imagewithtextScript($, Drupal) {
  Drupal.behaviors.imagewithtext = {
    attach(context) {

    },
  };
}(jQuery, Drupal));
